import React from 'react';

import { IChatInputMessage } from '@fly/shared';
import { FlyCopyButton } from '@fly/shared-ui';

import styles from '../../FlyChat.module.less';

interface FlyMessageActionsProps {
  message: IChatInputMessage;
}

export const FlyMessageActions: React.FC<FlyMessageActionsProps> = ({
  message,
}) => {
  // const { t } = useTranslation();
  return (
    <div
      className={styles.messageActionsContainer}
      data-testid='chat-message-actions'
    >
      {/*<IconButton*/}
      {/*  color='neutral'*/}
      {/*  variant='ghost'*/}
      {/*  size='1'*/}
      {/*  icon='thumbs_up'*/}
      {/*  data-testid='chat-like-action'*/}
      {/*/>*/}
      {/*<IconButton*/}
      {/*  color='neutral'*/}
      {/*  variant='ghost'*/}
      {/*  size='1'*/}
      {/*  icon='thumbs_down'*/}
      {/*  data-testid='chat-unlike-action'*/}
      {/*/>*/}
      {/*<IconButton*/}
      {/*  color='neutral'*/}
      {/*  variant='ghost'*/}
      {/*  size='1'*/}
      {/*  data-testid='chat-sync-action'*/}
      {/*  icon='sync'*/}
      {/*/>*/}
      <FlyCopyButton
        code={message?.content || ''}
        className='p-0 align-center flex hidden h-[24px] w-[24px] !max-w-[24px] items-center justify-center overflow-hidden'
        size={16}
      />
      {/*<Tooltip*/}
      {/*  content={t('app.dashboard.chat.auto_nav_tooltip', {*/}
      {/*    defaultValue: 'Navigate & take me there',*/}
      {/*  })}*/}
      {/*>*/}
      {/*  <IconButton*/}
      {/*    size='1'*/}
      {/*    color='neutral'*/}
      {/*    variant='ghost'*/}
      {/*    icon='auto_nav'*/}
      {/*    data-testid='chat-nav-action'*/}
      {/*  />*/}
      {/*</Tooltip>*/}
    </div>
  );
};
